module.exports = __webpack_public_path__ + "141d4a85/img/placeholder.888fcd0b.svg";